import { takeFirst, takeLast, abortEffect } from '@/common/utils/controllableSideEffects';

export default function (store) {
  store.$takeFirst = (actionName, ...args) => takeFirst({ action: store.dispatch, actionName }, ...args);
  store.$takeLast = (actionName, ...args) => takeLast({ action: store.dispatch, actionName }, ...args);
  store.$abortEffect = (actionName, ...args) => abortEffect({ action: store.dispatch, actionName }, ...args);
}
